// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowUpRectangle16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-up-rectangle': IconArrowUpRectangle;
    }
}

/**
 * The icon component for the 'arrowUpRectangle' icon
 */
export class IconArrowUpRectangle extends Icon {
    public constructor() {
        super(arrowUpRectangle16X16);
    }
}

registerIcon('icon-arrow-up-rectangle', IconArrowUpRectangle);
export const iconArrowUpRectangleTag = 'nimble-icon-arrow-up-rectangle';
